module.exports = {
  container: 'congrex/hcpList/container',
  search: 'congrex/hcpList/search',
  allBaseToggle: 'congrex/hcpList/allBaseToggle',
  findEvent: hcpUuid => `congrex/hcpList/findEvent/${hcpUuid}`
}
